import { Component, OnInit, Input } from '@angular/core';
import { fadeInOutTranslate } from 'app/shared/elements/animation';
import {IOption} from 'ng-select';
import { UserService } from 'app/users/shared/user.service';
import { FormGroup, FormControl } from '@angular/forms';
import { HRMSService } from '../../shared/hrms.service';
import { LogisticsService } from 'app/logistics-operations/shared/logistics.service';
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  animations: [fadeInOutTranslate]
})
export class SearchComponent implements OnInit {

  employees:any;
  employeesList:any;
  myEmployees: Array<IOption> = [];
  mySearchForm: FormGroup;
/*   @Input("branchOptions") branchOptions: Array<IOption> = [];
  @Input("departmentsOptions") departmentsOptions: Array<IOption> = []; */
branchOptions: Array<IOption> = [];
departmentsOptions: Array<IOption> = [];
p: number = 1;
  constructor(private userService:UserService,private hrmsService:HRMSService, private ls:LogisticsService) { }

  ngOnInit() {
    this.getAllBranches();
    this.getAllDepartments();
    this.getAllEmployees();
    this.initializeForm();
  }
  myOptions: Array<IOption> = [
    {label: 'John Mathew', value: 'BE'},
    {label: 'Maria Shawn', value: 'LU'},
    {label: 'Chris Mathew', value: 'BE'},
    {label: 'Shain Nathan', value: 'LU'},
    {label: 'John Mathew', value: 'BE'},
    {label: 'Maria Ashley', value: 'LU'},
    {label: 'Lamrath Abdulllah', value: 'NL'}
  ];

  myDept: Array<IOption> = [
    {label: 'All', value: 'all'},
    {label: 'HR', value: 'hr'},
    {label: 'Accounts', value: 'accounts'},
    {label: 'Field workers', value: 'fw'}
  ];

  companyassets: Array<IOption> = [
    {label: 'Mobile', value: 'mobile'},
    {label: 'Laptop', value: 'laptop'},
    {label: 'Phone', value: 'phone'},
    {label: 'Car', value: 'car'}
  ];

  myRoles: Array<IOption> = [
    {label: 'All', value: 'All'},
    {label: 'Supervisor', value: 'supervisor'},
    {label: 'Admin', value: 'admin'},
    {label: 'Driver', value: 'driver'},
    {label: 'Super Admin', value: 'super admin'}
  ];

  public getAllEmployees()
  {
  var x = this.userService.getAllUser();
  x.snapshotChanges().subscribe(item=>{
    this.employees = [];
    this.myEmployees = [];
    this.employeesList = [];
    this.myEmployees.push({label: "All", value: "All"});
    var i =0;
    item.forEach(element =>{
      var y = element.payload.toJSON();
      if(!(element.payload.child("role").val() == "customer") && element.payload.child("status").val() == "1" && element.payload.child("boardingStatus").val() == "onboard")
      {
        y["$key"] = element.key;
        if(i<9)
        {
          //this.employees.push(y);
          i++;
        }
        this.employees.push(y);
        this.employeesList.push(y);
        this.myEmployees.push({label: String(element.payload.child("name").val()), value: String(element.payload.child("employeeId").val())});
      }
    });
  });
}
public getAllBranches()
{
  var x = this.ls.getBranchAll();
  x.snapshotChanges().subscribe(item=>{
  this.branchOptions = [];
  this.branchOptions.push({label: 'All', value: 'All'});
    item.forEach(element =>{
        this.branchOptions.push({label: String(element.payload.child("name").val()), value: String(element.key)});
    });
  });
}
public getAllDepartments()
{
  var x = this.hrmsService.getAllDepartments();
  x.snapshotChanges().subscribe(item=>{
  this.departmentsOptions = [];
  this.departmentsOptions.push({label: 'All', value: 'All'});
    item.forEach(element =>{
        this.departmentsOptions.push({label: String(element.payload.child("name").val()), value: String(element.key)});
    });
  });
}
public initializeForm()
{
  this.mySearchForm = new FormGroup({
    employee: new FormControl('All'),
    branch: new FormControl('All'),
    department: new FormControl('All'),
    role: new FormControl('All')
  });
}
public onSubmit()
{
  
  if(this.mySearchForm.value.employee == "All" && this.mySearchForm.value.branch == "All" && this.mySearchForm.value.department == "All" && this.mySearchForm.value.role == "All")
  {
    return true;
  }
  else if(this.mySearchForm.value.employee != "All" && this.mySearchForm.value.branch != "All" && this.mySearchForm.value.department != "All" && this.mySearchForm.value.role == "All")
  {
    this.employees = [];
    this.employeesList.forEach(e=>{
      if(String(e.employeeId) === this.mySearchForm.value.employee || e.department === this.mySearchForm.value.department 
      || e.branch === this.mySearchForm.value.branch)
      {
        this.employees.push(e);
      }
    });
  }
  else
  {
    this.employees = [];
    this.employeesList.forEach(e=>{
      if(String(e.employeeId) === this.mySearchForm.value.employee || e.department === this.mySearchForm.value.department 
      || e.role === this.mySearchForm.value.role || e.branch === this.mySearchForm.value.branch)
      {
        this.employees.push(e);
      }
    });
  }
}
/* public onSubmit()
{
  this.employees = [];
  var x = this.userService.getAllUser();
  x.snapshotChanges().subscribe(item=>{
    this.employees = [];
    item.forEach(element =>{
      var y = element.payload.toJSON();
      var e = element.payload.val();
      console.log("e",e);
      if(String(e.employeeId) === this.mySearchForm.value.employee || e.department === this.mySearchForm.value.department 
      || e.role === this.mySearchForm.value.role || e.branch === this.mySearchForm.value.branch)
      {
        this.employees.push(y);
      }
    });
  });
} */
public clear():void{
  //this.employees = this.employeesList;
  this.ngOnInit();
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/employee/search/search.component.ts